import { ActivatedRoute } from '@angular/router';

import { loadStringFilterFromGetParams } from '../utils';
import { EventTypeStatus } from './event-type-enums';

export enum VoucherPackStatus {
  draft = 'DRA',
  active = 'ACT',
  retired = 'RET'
}

export enum VoucherPackVisibility {
  public = 'PUB',
  unlisted = 'UNL',
  staffOnly = 'STA'
}

export enum VoucherPackGiftDiscountType {
  currency = 'CUR',
  percentage = 'PER'
}

export interface VoucherPack {
  id: number;
  url: string;
  name: string;
  status: VoucherPackStatus;
  event_type_id: number | null;
  event_type_url: string | null;
  event_type_name: string | null;
  event_type_status: EventTypeStatus | null;
  event_category_id: number | null;
  event_category_url: string | null;
  event_category_name: string | null;
  number_of_vouchers: number;
  price: number;
  tax_rate_id: number;
  tax_rate_url: string;
  tax_rate_name: string;
  description: string;
  confirmation_text: string;
  payment_information_text: string;
  terms_and_conditions_checkbox_text: string;
  expiration_months: number;
  expiration_days: number;
  visibility: VoucherPackVisibility;
  allow_purchasing_for_unlinked_customers: boolean;
  allow_purchase_without_login: boolean;
  mailchimp_last_voucher_used_event_name: string;
  mailchimp_unused_vouchers_tag_name: string;
  mailchimp_purchased_by_customer_event_name: string;
  mailchimp_purchased_for_customer_event_name: string;
  revenue_account_codes: { [key: string]: string | null };
  created_at: string;
  updated_at: string;
  last_updated_by_id: number | null;
  last_updated_by_first_name: string | null;
  last_updated_by_last_name: string | null;
  last_updated_by_email: string | null;
}

export interface VoucherPackGiftingConfig {
  id: number;
  url: string;
  assigned_voucher_pack_ids: number[];
  assigned_voucher_pack_names: string[];
  max_future_delivery_date_days: number;
  expiration_days: number;
  gift_giver_terms_and_conditions: string;
  gift_recipient_terms_and_conditions: string;
  created_at: string;
  updated_at: string;
}

export interface VoucherPackGiftDiscount {
  id: number;
  url: string;
  is_automatic: boolean;
  code: string;
  name: string;
  discount_type: VoucherPackGiftDiscountType;
  amount: number;
  start_date?: string;
  end_date?: string;
  voucher_pack_ids: number[];
  voucher_pack_names: string[];
  created_at: string;
  updated_at: string;
  last_updated_by_id: number | null;
  last_updated_by_first_name: string | null;
  last_updated_by_last_name: string | null;
  last_updated_by_email: string | null;
}

export interface VoucherPackFilters {
  search?: string;
  status?: VoucherPackStatus;
}

export interface VoucherPackGiftDiscountFilters {
  search?: string;
}

export function loadVoucherPackFiltersFromGetParams(activatedRoute: ActivatedRoute): VoucherPackFilters {
  const filters: VoucherPackFilters = {};

  const initialQPs = activatedRoute.snapshot.queryParamMap;

  loadStringFilterFromGetParams(filters, 'search', initialQPs);
  loadStringFilterFromGetParams(filters, 'status', initialQPs);

  return filters;
}

export function getVoucherPackStatusDisplay(status: VoucherPackStatus): string {
  if (status === VoucherPackStatus.draft) {
    return 'Draft';
  } else if (status === VoucherPackStatus.active) {
    return 'Active';
  } else if (status === VoucherPackStatus.retired) {
    return 'Retired';
  } else {
    return 'Unknown';
  }
}
